(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/themes/sport-handball/assets/javascripts/init-box.js') >= 0) return;  svs.modules.push('/components/themes/sport-handball/assets/javascripts/init-box.js'); "use strict";

(function (svs) {
  svs = svs || {};
  svs.themes = svs.themes || {};
  svs.themes.sport_handball = svs.themes.sport_handball || {};

  svs.themes.sport_handball.initStatusStart = function (data) {
    if (svs.themes.sport_handball.isLive(data.status.id)) {
      if (data.status.id === 6) {
        return '<div class="brick match-status brick-active f-condensed align-center">1:A</div>';
      }

      if (data.status.id === 7) {
        return '<div class="brick match-status brick-active f-condensed align-center">2:A</div>';
      }

      if (data.status.id === 15) {
        return '<div class="brick match-status brick-active f-condensed align-center">HT</div>';
      }

      if (data.status.id === 19) {
        return '<div class="brick match-status brick-active f-condensed align-center">ÖT</div>';
      }

      if (data.status.id === 22) {
        return '<div class="brick match-status brick-active f-condensed align-center">STR</div>';
      }

      if (data.status.id === 14 || data.status.id === 16
      || data.status.id === 18
      ) {
          return '<div class="brick match-status brick-active f-condensed align-center">PAUS</div>';
        }

      return '<div class="brick match-status brick-active f-condensed align-center">Q1</div>';
    } else if (svs.themes.sport_handball.isEnded(data.status.id)) {
      if (data.status.id === 32) {
        return '<div class="brick match-status brick-border brick-inactive f-condensed align-center">ÖT</div>';
      }

      if (data.status.id === 33) {
        return '<div class="brick match-status brick-border brick-inactive f-condensed align-center">STR</div>';
      }

      return '<div class="brick match-status brick-border brick-inactive f-condensed align-center">FT</div>';
    } else if (data.startTime) {
      return "<div class=\"brick match-status brick-border f-condensed align-center\">".concat(svs.themes.formatTime(data.startTime), "</div>");
    }

    return '';
  };


  svs.themes.sport_handball.hasMatchMinutes = function () {
    return false;
  };
})(svs);
 })(window);